import { GET_RATECALCULATION } from "resources/actionTypes";


export function getRateCalculation(data) {
  return {
    type: GET_RATECALCULATION.GET_RATECALCULATION_REQUESTED,
    payload: data
  };
}